"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomViewStore_1 = require("@/room/room_view/roomViewStore");
const react_i18next_1 = require("react-i18next");
const functions_1 = require("@/common/functions");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const Tabs_1 = __importDefault(require("@mui/material/Tabs"));
const Tab_1 = __importDefault(require("@mui/material/Tab"));
const _1 = require(".");
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const roomCreateStep = (0, react_redux_1.useSelector)((state) => state.roomCreateStep);
    const isPreview = roomCreateStep === 'preview';
    const detailRef = (0, react_1.useRef)(null);
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px');
    const headerHeight = maxWidth768 ? 50 : isPreview ? 101 : 51;
    const scrollToTabs = () => window.setTimeout(() => {
        if (detailRef.current) {
            let detailOffsetTop = detailRef.current.offsetTop;
            window.scrollTo({
                behavior: 'smooth',
                top: detailOffsetTop - headerHeight,
            });
        }
    }, 300);
    const roomId = (0, react_redux_1.useSelector)((state) => state.roomData.id);
    const dispatch = (0, react_redux_1.useDispatch)();
    const openNotice = () => {
        dispatch((0, roomViewStore_1.getLeaderNotice)(roomId));
        scrollToTabs();
    };
    const openQna = () => {
        dispatch((0, roomViewStore_1.getComments)(roomId));
        scrollToTabs();
    };
    const [tabValue, setTabValue] = (0, react_1.useState)('contents');
    (0, react_1.useEffect)(() => {
        if (roomId) {
            const tabValueParam = (0, functions_1.getSearchParam)('detail');
            if (tabValueParam) {
                setTabValue(tabValueParam);
                if (tabValueParam === 'notice')
                    openNotice();
                if (tabValueParam === 'qna')
                    openQna();
            }
        }
    }, [roomId]);
    const isContents = tabValue === 'contents';
    const isNotice = tabValue === 'notice';
    const isQna = tabValue === 'qna';
    const deliveryType = (0, react_redux_1.useSelector)((state) => state.deliveryType);
    const isCustomDelivery = deliveryType === '6';
    const isLeaderBlocked = (0, react_redux_1.useSelector)((state) => state.roomData.is_leader_block_user);
    const isCustomDeliveryShowable = isCustomDelivery && !isLeaderBlocked;
    const isNoticeShowable = isNotice && !isPreview;
    const isQnaShowable = isQna && !isPreview;
    const isCartOrderShowable = isContents && !isPreview;
    const isDemandSurvey = (0, react_redux_1.useSelector)((state) => state.isDemandSurvey);
    const switchToQna = () => {
        setTabValue('qna');
        openQna();
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(DetailWrapper, Object.assign({ ref: detailRef }, { children: [(0, jsx_runtime_1.jsxs)(Tabs_1.default, Object.assign({ value: tabValue, onChange: (_, val) => setTabValue(val), variant: "fullWidth", TabIndicatorProps: { style: { backgroundColor: 'black', top: 0 } } }, { children: [(0, jsx_runtime_1.jsx)(Tab_1.default, { value: "contents", label: t('상세정보'), onClick: scrollToTabs }), (0, jsx_runtime_1.jsx)(Tab_1.default, { value: "notice", label: t('공지사항'), onClick: openNotice, disabled: isPreview }), (0, jsx_runtime_1.jsx)(Tab_1.default, { value: "qna", label: t('작품 문의'), onClick: openQna, disabled: isPreview })] })), isContents && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!isLeaderBlocked && (0, jsx_runtime_1.jsx)(_1.ProductsList, {}), isCustomDeliveryShowable && (0, jsx_runtime_1.jsx)(_1.CustomDelivery, {}), (0, jsx_runtime_1.jsx)(_1.Contents, {}), !isDemandSurvey && (0, jsx_runtime_1.jsx)(_1.Refund, {}), (0, jsx_runtime_1.jsx)(_1.CategoryTag, {}), !isPreview && !isDemandSurvey && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(_1.CustomerCenter, { switchToQna: switchToQna }), (0, jsx_runtime_1.jsx)(_1.CompanySellerInfo, { switchToQna: switchToQna }), (0, jsx_runtime_1.jsx)(_1.FondeeFooter, {})] }))] })), isNoticeShowable && (0, jsx_runtime_1.jsx)(_1.Notice, {}), isQnaShowable && (0, jsx_runtime_1.jsx)(_1.QnA, {})] })), isCartOrderShowable && (0, jsx_runtime_1.jsx)(_1.CartOrder, {})] }));
}
exports.default = default_1;
const DetailWrapper = styled_1.default.div `
  font-size: 14px;
  .MuiTabs-root {
    position: sticky;
    top: 50px;
    background-color: white;
    z-index: 2;
    .MuiTab-root {
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      background-color: rgba(255, 255, 255, 0.5);
      color: rgba(0, 0, 0, 0.6);
      font-size: 13px;
      font-weight: 400;
      opacity: 1;
    }
    .Mui-selected {
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-bottom: 0;
      background-color: white;
      color: black;
      font-size: 14px;
      font-weight: 600;
    }
  }
`;
